/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSimilarItem_user = {
    readonly canShowSellerName: boolean | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "PdpRespSimilarItem_user";
};
export type PdpRespSimilarItem_user$data = PdpRespSimilarItem_user;
export type PdpRespSimilarItem_user$key = {
    readonly " $data"?: PdpRespSimilarItem_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItem_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'da2babb66b917e3ca5d688605258153e';
export default node;
